module.exports = __webpack_public_path__ + "img/DaSoIrgendwo.49ce4444.svg";